import type {
  V1UpdateBookingAddOnsRequest,
  V1UpdateBookingAddOnsResponse,
} from '@ennismore/booking-api-client';
import { useMutation, useQueryClient } from 'react-query';

import { APIDialect, useEnnismoreApiClientConfig } from '@/api';
import '@/api';
import { getBookingServiceClient } from '@/booking/services/client';
import { mapNetworkError } from '@/errors';

import { AddOnError } from '../errors';
import { useSessionId } from '@/session/use-session-id.hook';

interface Request {
  body: V1UpdateBookingAddOnsRequest;
  dialect: APIDialect;
}

export const updateAddOnsMutationKey = 'updateBookingAddOns' as const;

export const useUpdateBookingAddOnsMutation = () => {
  const clientConfig = useEnnismoreApiClientConfig();
  const queryClient = useQueryClient();
  const sessionId = useSessionId();

  return useMutation<V1UpdateBookingAddOnsResponse, AddOnError, Request>(
    async ({ body, dialect }) => {
      try {
        return await getBookingServiceClient(
          clientConfig,
          dialect
        ).updateBookingAddOns({ ...body, sessionId });
      } catch (e) {
        console.error(e);
        throw new AddOnError(await mapNetworkError(e));
      } finally {
        /**
         * Ideally should be part of onSettled callback within the mutation consumer,
         * to keep this decoupled. However it's the only way (afaik) to make useIsMutating hook's result
         * to be prolonged until the booking gets refetched.
         * This way we can keep the CTA button disabled and prevent stale state.
         */
        await queryClient.invalidateQueries('bookingSummary');
      }
    },
    {
      mutationKey: updateAddOnsMutationKey,
    }
  );
};
